export default "__VITE_ASSET__w8b_dYeh__"